import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Trash2, Plus } from "lucide-react";
import { toast } from "sonner";

const GROUPS = [
  { v: "all", l: "Todos os produtos" },
  { v: "aneis", l: "Anéis / Alianças (14, 15, 16...)" },
  { v: "colar", l: "Colares (45cm, 50cm...)" },
  { v: "roupa", l: "Roupa / genéricos (PP, P, M, G, GG)" },
];

export default function AdminSizes() {
  const [list, setList] = useState([]);
  const [label, setLabel] = useState("");
  const [group, setGroup] = useState("all");
  const load = () => api.get("/admin/sizes").then(({ data }) => setList(data));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    if (!label.trim()) return;
    const sort = list.length > 0 ? Math.max(...list.map((s) => s.sort || 0)) + 1 : 0;
    try {
      await api.post("/admin/sizes", { label: label.trim(), group, sort });
      toast.success("Tamanho adicionado");
      setLabel(""); load();
    } catch (err) { toast.error("Erro"); }
  };
  const del = async (id) => { if (window.confirm("Remover tamanho?")) { await api.delete(`/admin/sizes/${id}`); load(); } };

  const grouped = GROUPS.map((g) => ({ ...g, items: list.filter((s) => (s.group || "all") === g.v) }));

  return (
    <div data-testid="admin-sizes">
      <h1 className="font-display text-3xl text-[#49392F] mb-2">Tamanhos</h1>
      <p className="text-[13px] text-[#49392F]/70 mb-8">
        Tamanhos disponíveis para seleção no cadastro de produtos e no filtro do catálogo.
      </p>

      <form onSubmit={save} className="bg-white border border-[#C2A064]/20 p-5 grid grid-cols-1 md:grid-cols-[1fr_1.5fr_auto] gap-3 mb-8">
        <input
          className="duo-input"
          placeholder="Ex.: 14, 15, P, M, 45cm..."
          value={label}
          onChange={(e) => setLabel(e.target.value)}
          data-testid="size-label-input"
        />
        <select className="duo-input" value={group} onChange={(e) => setGroup(e.target.value)} data-testid="size-group-select">
          {GROUPS.map((g) => <option key={g.v} value={g.v}>{g.l}</option>)}
        </select>
        <button className="duo-btn duo-btn-primary" data-testid="size-save-button">
          <Plus size={14} /> Adicionar
        </button>
      </form>

      <div className="space-y-6">
        {grouped.map((g) => (
          <div key={g.v}>
            <h3 className="text-[11px] tracking-[0.3em] uppercase text-[#49392F]/80 mb-3">{g.l}</h3>
            {g.items.length === 0 ? (
              <div className="text-[12px] text-[#49392F]/50">Nenhum tamanho neste grupo.</div>
            ) : (
              <div className="flex flex-wrap gap-2">
                {g.items.map((s) => (
                  <div key={s.id} className="inline-flex items-center gap-2 bg-white border border-[#C2A064]/20 pl-3 pr-1 py-1.5">
                    <span className="text-[13px] text-[#49392F]">{s.label}</span>
                    <button onClick={() => del(s.id)} className="p-1 text-[#49392F]/60 hover:text-[#49392F]" aria-label="remover">
                      <Trash2 size={12} />
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
